<template>
    <div>

        <b-form-row>
            <form-field class="col-xs-12 col-lg-8 col-xl-4 mt-3 required mr-3"
                :editable="true"
                :label="getFieldLabel('receiverOrganization')"
                :value="object.receiverOrganizationObject"
                :feedback="liveFeedback('receiverOrganization')">
                <template #field>
                    <single-select name="receiverOrganization"
                                   class="flex-grow-1 mr-2"
                                   v-model="form['receiverOrganizationObject']"
                                   :url="getOrganizationsUrl"
                                   :initial-filters="getOrganizationsInitialFilters"
                                   :label="getFieldLabel('receiverOrganization')"
                                   :state="getValidationClass('receiverOrganization')"
                                   v-on:select-changed="onReceiverOrganizationChanged"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                </template>
            </form-field>
        </b-form-row>

        <b-form-row>
            <form-field class="required col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 mt-3 mr-3  mr-lg-5"
                         :label="getFieldLabel('receiverContractType')"
                         :editable="Boolean(form.receiverOrganization)"
                         :value="getContractTypeText">
                <template #field>
                    <radio-list id="receiverContractType" name="receiverContractType"
                                v-model="form.receiverContractType" :url="getContractTypesUrl"
                                @radio-changed="onReceiverContractTypeChanged"/>
                </template>
            </form-field>

            <form-field class="col-xs-12 col-lg-8 col-xl-4 mt-3 required mr-3"
                :editable="Boolean(form.receiverOrganization) && Boolean(form.receiverContractType)"
                :label="getFieldLabel('receiverContract')"
                :value="getContractValueName"
                :feedback="liveFeedback('receiverContract')">
                <template #field>
                    <single-select name="receiverContract"
                                   class="flex-grow-1 mr-2"
                                   v-model="form['receiverContractObject']"
                                   :url="getContractsUrl"
                                   label-key="full_description"
                                   :initial-filters="getContractInitialFilters()"
                                   :label="getFieldLabel('receiverContract')"
                                   :state="getValidationClass('receiverContract')"
                                   v-on:select-changed="onModelObjectSingleSelectChanged"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                </template>
            </form-field>
        </b-form-row>

<!--        <b-form-row>-->
<!--            <form-field :label="getFieldLabel('forLife')"-->
<!--                        class="col-xs-12 col-sm-8 col-md-4 col-lg-3 p-0 mr-3 mt-3 mb-3"-->
<!--                        :value="readonlyForLifeValue"-->
<!--                        :editable="isEditable('forLife')"-->
<!--                        :feedback="liveFeedback('forLife')">-->
<!--                <template #field>-->
<!--                    <b-form-checkbox size="lg" v-model="form.forLife" @change="onForLifeChange" switch >-->
<!--                        <span v-if="form.forLife">Да</span>-->
<!--                        <span v-else>Нет</span>-->
<!--                    </b-form-checkbox>-->
<!--                </template>-->
<!--            </form-field>-->
<!--        </b-form-row>-->

    </div>
</template>

<script>
import SingleSelect from "@/components/Select/SingleSelect.vue";
import RadioList from "@/components/Select/RadioList.vue";
import FormField from "@/components/Forms/FormField.vue";
import DateTimePicker from "@/components/Forms/DateTimePicker.vue";
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
import api from "@/api";
import {TransferEventAttributes} from "@/pages/AppPages/Events/Disposal/transfer";
import {todayStr} from "@/utils/dateFormat";
import {CONTRACT_TYPE} from "@/pages/AppPages/Catalogs/Contracts/contract";

export default {
    name: "TransferAttributes",
    components: {SingleSelect, RadioList, FormField, DateTimePicker },
    mixins: [ObjectComponentMixin, AttributeMixin],
    computed: {
        // ownerTypeUrl() { return api.animals.ownerTypes.list(api.animals.default.list()) },
        // addressUrl() {return api.addresses.search.list()}
        readonlyForLifeValue() {
            return this.object.forLife ? 'Да' : 'Нет'
        },
        getOrganizationsUrl() {
            return api.animals.shelters.list();  // TODO: уточнить, все ли организации могут быть в этом списке, или только приюты
        },
        getContractsUrl() {
            return api.contracts.receivers.list();
        },
        getContractTypesUrl() {
            return api.contracts.types.list();
        },
        getContractTypeText() {
            return CONTRACT_TYPE[this.receiverContractType]
        },
        getContractValueName() {
            return null
        },
        getOrganizationsInitialFilters() {
            return [ {key: 'has_contract', value: true} ]
        },
    },
    methods: {
        onForLifeChange() {
            this.$v.form.forLife.$touch();
        },
        getContractInitialFilters() {
            return [
                { key: 'contract_type', value: this.form.receiverContractType },
                { key: 'contractor', value: this.form.receiverOrganization },
                { key: 'is_valid', value: true }
            ]
        },
        onReceiverOrganizationChanged(name, item) {
            this.onModelObjectSingleSelectChanged(name, item)
            this.form['receiverContract'] = null;
            this.form['receiverContractObject'] = {};
            this.$v.form.receiverContract.$touch();
            this.form['receiverContractType'] = null;
            this.$v.form.receiverContractType.$touch();
        },
        onReceiverContractTypeChanged(name, item, data) {
            this.onModelObjectRadioChanged(name, item, data)
            this.form['receiverContract'] = null;
            this.form['receiverContractObject'] = {};
            this.$v.form.receiverContract.$touch();
        }
    },
    beforeMount() {
        this.objectClass = TransferEventAttributes;
        this.initialize();
    },
    mounted() {
        this.onMount();
        this.resetForm();
    },
}
</script>

<style scoped>

</style>